import {useQuery} from '@tanstack/react-query';
import {consentsApi} from '../api';
import {ConsentDocumentDetailModel} from '../model';

export const useConsentDocumentById = (documentId: string) => {
  return useQuery<ConsentDocumentDetailModel, Error>({
    queryKey: ['consent-document', documentId],
    queryFn: () => consentsApi.getDocumentById(documentId),
    enabled: !!documentId,
    staleTime: 60 * 1000,
  });
};
